import { Component, Input, OnInit } from "@angular/core";
import { UserProfile, AccountService } from "src/app/services/account.service";

@Component({
  selector: "app-statement-details",
  templateUrl: "./statement-details.component.html",
  styleUrls: ["./statement-details.component.scss"],
})
export class StatementDetailsComponent implements OnInit {
  today = new Date();
  @Input() statement;
  profile: UserProfile;

  constructor(private _accService: AccountService) {
    this.profile = _accService.getUserProfile();
  }

  ngOnInit(): void {
  }

  get totalStatementComm() {
    return true;
    // return this.statement.InvoiceComm.reduce(function (a, b) {
    //   return a + b.CommValue;
    // }, 0);
  }
}
